import request from "@/util/http";
//详情
export function detail(params) {
	return request({
		url: '/marketing/shop/marketing/detail',
		method: 'get',
		params: params,
	})
}


/**
 * 详情
 * @param {Object} params
 */
export function marketing_goods(params) {
	return request({
		url: '/marketing/shop/marketing/marketing_goods',
		method: 'get',
		params: params,
	})
}

/**
 * 活动列表
 * @param {Object} params
 */
export function marketing_activities(params) {
	return request({
		url: '/marketing/shop/marketing/marketing_activities',
		method: 'get',
		params: params,
	})
}



// module.exports = {
// 	detail,
// 	marketing_goods,
// 	marketing_activities
// }
